<div
	[editableInStoryblok]="_editable"
	[ngClass]="{ 'h-full': !stopGrow() }"
	class="w-full"
>
	@if (components) {
		@let button = buttons();
		<vp-persuade-card
			[cardLinkType]="button?.secondaryCtaLinkType"
			[cardUrl]="button?.secondaryCtaUrl"
			[ctaLinkType]="button?.ctaLinkType"
			[ctaText]="button?.ctaText"
			[ctaType]="buttonCtaType()"
			[ctaUrl]="button?.ctaUrl"
			[headingType]="headingType()"
			[images]="flatImages()"
			[linkListConfig]="linkList()"
			[overline]="headingOverline()"
			[secondaryCtaLinkType]="button?.secondaryCtaLinkType"
			[secondaryCtaText]="button?.secondaryCtaText"
			[title]="headingTitle()"
			[useVerticalCard]="!isHorizontal()"
			imageVariant="grid"
		>
			<ng-container content>
				@for (blok of contentInputs(); track $index) {
					<ndc-dynamic
						[ndcDynamicComponent]="components[blok['component']]"
						[ndcDynamicInputs]="blok"
						class="hidden"
					/>
				}
			</ng-container>
		</vp-persuade-card>
	}
</div>
